import { ApplicationSectionStatus } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getApplicationSectionStatusList(): Promise<
  ApplicationSectionStatus[]
> {
  return await prisma.applicationSectionStatus.findMany();
}
